import { GET_REGIONS} from "../mutation-types";
// initial state
const state = {
  map: {}
};

// getters
const getters = {};
// actions
const mutations = {
  [GET_REGIONS](state){
    Ajax.get('/api/cps/getRegions')
      .then((res) => {
        const regions = res.data.regions || [];
        for (let i = 0; i < regions.length; i++) {
          state.map[regions[i].region] = regions[i].regionName;
        }
      })
  }
}

const actions = {
  [GET_REGIONS]: ({commit}) => commit(GET_REGIONS)
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/region.js